import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MenuPage } from '../menu/menu.page';
import { AppComponent } from '../../app.component';
import { TranslateService } from '@ngx-translate/core';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { NavigationService, NAVIGATIONURLS } from 'src/app/services/navigation.service';
import { InfoModalComponent } from 'src/app/components/info-modal/info-modal.component';
import {PreorderType} from "../../../smoothr-web-app-core/enums/PreorderType";
import {CheckoutModalComponent} from "../../components/checkout-modal/checkout-modal.component";
import {numberToCurrency} from "../../../smoothr-web-app-core/utils/utils";
import {OrderUtils} from "../../../smoothr-web-app-core/utils/order-utils";
import {
	applyExtrasToOrder,
	buildExtrasSelection,
	ExtraSelection,
	extrasTotalPrice,
	EXTRAS_MAX_QUANTITY
} from "../../helpers/extras-functions";

@Component({
	selector: 'app-order',
	templateUrl: './order.page.html',
	styleUrls: ['order.page.scss'],
})
export class OrderPage extends RepositoryDirective implements OnInit {
	@ViewChild('swiper', { static: false }) swiperEl: ElementRef;

	static url = 'order';
	static failUrlWithPaymentParam = 'payment/fail/:payment';
	static cancelUrlWithPaymentParam = 'payment/cancel/:payment';
	static paymentFailUrl = 'payment/fail';
	static paymentCancelUrl = 'payment/cancel';

	tip = 0;
	loading = false;
	extras: ExtraSelection[] = [];
	total = 0;
	personCount: number = null;

	constructor(
		protected repo: RepositoryService,
		private translate: TranslateService,
		private snackbarCtrl: MatSnackBar,
		private navigationService: NavigationService,
		private router: Router,
		private modalCtrl: ModalController
	) {
		super(repo);
	}

	get title(): string {
		return this.translate.instant('menu_page.basket_title');
	}

	ngOnInit(): void {
		super.ngOnInit();
		console.log('ngOnInit');
		switch (window.location.pathname) {
			case '/' + NAVIGATIONURLS.order():
				break;
			case '/' + NAVIGATIONURLS.paymentCancel:
				console.log(this.translate.instant('order.payment_cancel'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_cancel'), null, {
					duration: 2000,
				});
				break;
			case '/' + NAVIGATIONURLS.paymentFail:
				console.log(this.translate.instant('order.payment_fail'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_fail'), null, {
					duration: 5000,
				});
				break;
		}
		console.log(this.router.url);
		if (this.router.url.includes('/payment/fail')) {
			// InfoModalComponent.show(this.modalCtrl, {
			// 	title: 'Something went wrong',
			// 	info: ' The payment couldn’t be processed. Please contact kaisin. X +41 76 216 67 70 OR +41 76 216 67 70.',
			// });
			this.router.navigateByUrl('/' + NAVIGATIONURLS.menu());
		}
	}


	nextSlide() {
		this.extras = buildExtrasSelection(this.repo._venue, this.repo._order);
		this.updateTotal();
		this.swiperEl.nativeElement.swiper.slideNext()
	}

	updateTotal() {
		this.total = extrasTotalPrice(this.repo._order, this.extras);
	}

	onPersonCountChange(value: number) {
		const personCount = Math.trunc(Number(value));
		if (!personCount || personCount < 1) {
			return;
		}
		this.setExtrasQuantity(Math.min(personCount, EXTRAS_MAX_QUANTITY));
	}

	setExtrasQuantity(quantity: number) {
		this.extras.forEach(extra => (extra.quantity = quantity));
		this.updateTotal();
	}

	async dismiss() {
		const order = this.order;
		applyExtrasToOrder(order, this.extras);
		this.repo.onOrderChange(order);

			const result = await CheckoutModalComponent.show(this.modalCtrl, null, this.order, null);
			if (result.data === undefined) return;

			this.order.orderAt = result.data.orderAt;
			this.order.preorder = result.data.preorder;
			this.tip = result.data.tip;

			this.repository.onOrderChange(this.order);
			try {
				await this.repository.createOrderWithPayment(
					this.modalCtrl,
					this.translate,
					this.order,
					this.tip,
					loading => (this.loading = loading),
					this.snackbarCtrl,
					false,
					false,
					null
				);
			} catch (e) {
				console.log(JSON.parse(JSON.stringify(e)));
			}

		this.repo.onOrderChange(this.repo._order);
		this.modalCtrl.dismiss();
	}

	openMap() {
		this.navigationService.map()
		setTimeout(() => this.modalCtrl.dismiss())
	}


	remove(extra: ExtraSelection) {
		extra.quantity = Math.max(extra.quantity - 1, 0)
		this.updateTotal();
	}

	add(extra: ExtraSelection) {
		extra.quantity = Math.min(extra.quantity + 1, EXTRAS_MAX_QUANTITY)
		this.updateTotal();
	}


	async backClick() {
		await this.navigationService.menu();
	}

	protected readonly numberToCurrency = numberToCurrency;
	protected readonly OrderUtils = OrderUtils;
}
